<template>
	<div>
		<label>{{ text }}<span v-show="isMandatory" class="asterik">*</span></label>
		<div class="config-radio-parent config-radio-parent-2">
			<b-form-group v-slot="{ ariaDescribedby }">
				<b-form-radio-group
					id="radio-group-1"
					v-model="selected"
					:options="options"
					:aria-describedby="ariaDescribedby"
					name="radio-options"
					:disabled="disabled"
					@change="updateData"
				></b-form-radio-group>
			</b-form-group>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	props: {
		text: {
			type: String,
			default: "Label",
		},
		isMandatory: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Array,
			default: () => [],
		},
		selected: {
			type: String,
			default: null,
		},
	},
	methods: {
		updateData() {
			this.$emit("updateData", this.selected);
		},
	}
};
</script>

<style>
.config-radio-parent-2 .custom-control {
	margin-right: 40px !important;
}
</style>
